var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"base-container",attrs:{"element-loading-text":"加载或处理中,请稍候...","element-loading-background":"rgba(0, 0, 0, 0.8)"}},[_vm._t("default"),_c('artisan-msg-box',{ref:"msg"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }